import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=18b899de&scoped=true"
import script from "./uploadImg.vue?vue&type=script&lang=js"
export * from "./uploadImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=18b899de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b899de",
  null
  
)

export default component.exports